module.exports = __webpack_public_path__ + "static/media/Sensory9274cb82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/Sensory.svg
// module id = 1309
// module chunks = 0